<template>
  <main class="main main--confirm">
    <div class="group group--sidebar group--df group--flex mw1920">
      <div class="group--flex confirm__bg">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 mw600"
          v-html="confirmMessage" />
        <p class="p mw600">{{ confirmDescription }}</p>

        <module-button
          v-if="confirmButtonLink"
          class="mw220"
          button="primary"
          :link="link"
        >
          {{ buttonText }}
        </module-button>

        <module-button
          v-if="confirmButtonAction"
          class="mw300"
          button="primary"
          type="button"
          :loading="isLoading"
          @click.native="triggerAction"
        >
          {{ buttonText }}
        </module-button>
      </div>

      <img class="confirm__image" :src="image" alt="">
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Mixins
import MixinIntakeProgress from 'components/IntakeProgress';

import characters from 'images/intake/f2f-characters.png';

const images = {
  characters,
};

// Export
export default {
  name: 'view-error',

  // Mixins
  mixins: [
    MixinIntakeProgress,
  ],

  // Data
  data() {
    return {
      isLoading: false,
      image: images.characters,
    };
  },
  
  // Computed
  computed: {
    ...mapGetters('app', [
      'confirmMessage',
      'confirmDescription',
      'confirmButtonAction',
      'confirmButtonLink',
      'confirmButtonLabel',
    ]),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('appointment', ['tempAppointmentData']),
    ...mapGetters('app', ['org']),

    link() {
      return this.confirmButtonLink || 'home';
    },

    buttonText() {
      return this.confirmButtonLabel || 'Submit';
    },
  },


  // Methods
  methods: {
    ...mapActions('app', ['setConfirmMessage', 'setConfirmButton']),

    triggerAction() {
      if ( this.confirmButtonAction ) {
        this.isLoading = true;
        this.$store.dispatch(this.confirmButtonAction)
          .then(() => {
            this.isLoading = false;
          });
      }
    },
  },

  beforeRouteEnter (to, from, next) {
    if ( from.name === 'face-2-face' ) {
      next(vm => {
        vm.checkIntakeRequirements(vm.isAuthenticated ? null : 'default', 'f2f', 1, 'appointmentType');
      });
    } else {
      next(vm => {
        if ( !vm.confirmMessage ) {
          next({
            name: 'home',
          });
        }
      });
    }
  },

  // Lifecycles
  destroyed() {
    this.setConfirmMessage('');
    this.setConfirmButton(null);
  },
};
</script>



// WEBPACK FOOTER //
// Confirm.vue?2aaa0b5b